import React from "react";

const ankita_karhade = () => {
  return (
    <div>
      <h1>Ankita Karhade</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        The eligibility criteria was: CS branch with 8+ CGPA
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The aptitude test was conducted online on 6th August. The interviews
        were held on 8th August. The shortlist for interviews was announced
        right after the pre-placement talk (PPT), and interviews began
        immediately after.{" "}
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude test included 3 coding questions- one “correct the code”
        type, one easy, and one hard. I could pass only 3 test cases for the
        hard one but completed the other two. There were also 3 SQL queries
        (moderate difficulty) and 10–15 MCQs on topics like OOP, DBMS, DSA, and
        general aptitude.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        19 students were shortlisted for the interviews
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The shortlist was announced on the 8th after the PPT, and interviews
        were held on the same day. I didn’t really have any time to prepare, but
        I had already gone through my resume, my projects and possible questions
        on them for an interview before.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were 2 rounds - Technical and HR.
        <br />
        The rounds started at around 12 PM, right after the PPT. There were 19
        interviewees, and my turn came around 4 PM. My technical interview
        lasted about an hour, longer than most others. I was asked a wide range
        of questions based on my internship and core CS subjects.
      </p>

      <p>
        I couldn’t answer a few questions, so at the end I asked the interviewer
        how I could improve from an employee perspective. He advised me to focus
        on one area, as my resume mentioned both frontend and backend, but I
        wasn’t deeply confident in either. I explained that since we’re only in
        the start of our third year, exploring multiple areas made sense as
        companies don’t hire for very specific roles. He agreed and said it was
        a good interview.
      </p>

      <p>
        Students were sent for the HR round right after their technical
        interviews. Around 7-8 were shortlisted for HR. My technical round ended
        at 5 PM, and I was immediately sent for HR, which was the last round.
        The final list of selected students was announced soon after - 6
        candidates were selected.
      </p>

      <p>
        The HR round included general questions like describing yourself, your
        achievements, failures, strengths, and weaknesses. It was more of a
        conversation about my personality and experiences, lasting around 20
        minutes. It felt more like a formality than an evaluation round.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
      </p>

      <p>
        I was asked detailed questions on DBMS and OOP.
        <br />
        The interview started with an introduction and questions about my
        internship, where I had implemented a multi-agent system using OpenAI -
        essentially a chatbot with multiple functions. The interviewer clarified
        some details and then moved to OOP concepts. As I answered, he asked
        deeper, scenario-based questions - like how I’d implement a class for a
        “flash sale” on an e-commerce site, what constraints to apply, and what
        would happen if certain conditions changed.
      </p>

      <p>
        He also asked about what happens when a webpage loads after entering a
        URL (CNS-based), API design for given scenarios, SQL queries on joins
        and limits, and general DBMS concepts. The round ended with a “correct
        the code” question.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
      </p>

      <ul>
        <li>LeetCode for DSA (Striver SDE Sheet) </li>
        <li>One-shot videos for CN and OS </li>
        <li>DBMS playlists on YouTube</li>
      </ul>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Practice consistently during vacations and throughout internship season.
        Theory subjects are manageable, but coding requires regular effort. I
        used to solve 2-3 LeetCode problems daily- topic by topic, starting from
        easy to medium and then hard.
        <br />
        If I got stuck, I’d check the solution, understand it, and then solve a
        similar problem myself (especially for the hard ones).
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        A few came up, mainly in the HR round. In the technical round, I was
        asked about my second-year internship but not much about projects.
        <br />
        In the HR round, I was asked several questions about extracurriculars
        and clubs. I mentioned being the Vice President of the English Section
        of the Debate Club, explained our activities, my role, achievements, and
        what I learned. I also discussed my hobbies.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        They focus heavily on your understanding of core basics. The
        scenario-based questions are open-ended- they don’t look for a single
        “correct” answer, but rather how you think, approach problems, and adapt
        your solutions to new requirements.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        The internship season is stressful with classes, frequent tests, and
        seeing others get internships can be demotivating. It’s true that
        sometimes results feel arbitrary, but consistent effort always pays off.
        Focus on your own growth instead of comparison. Rejections teach you
        resilience and self-awareness. Keep improving, fixing your mistakes, and
        you’ll eventually succeed.
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Phone No :</strong> 9175188284
        <br />
        <strong>Email :</strong> <a href="mailto:ankitapkarhade@gmail.com">ankitapkarhade@gmail.com</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/ankita-karhade-a5a90b215"> Ankita Karhade</a>
      </p>
    </div>
  );
};

export default ankita_karhade;
